<!--US Page-->
<div class="dtf-accountdetails">
<style>
    .sitemap-page {
    max-width: 1000px;
    margin: 0 auto;
    padding: 40px 20px;
    font-family: 'corporateSRegular';
}
.card{
     width: 100%;
     transition: none;
     transform: none;
}
.card:hover {
  transform: none;
  box-shadow: none;
}

.sitemap-page h1 {
    font-size: 40px;
    font-weight: 600;
    color: #000;
    margin-bottom: 40px;
    text-align: left;
    font-family: 'corporateSRegular';
}

/* Stack all sections vertically */
.sitemap-grid {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.section {
    padding-bottom: 24px;
    border-bottom: 1px solid #dcdcdc;
}

.section:last-child {
    border-bottom: none;
}

.section h2 {
    font-size: 22px;
    font-weight: 600;
    color: #00566A;
    margin-bottom: 16px;
    font-family: 'corporateSRegular';
}

.section ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.section li {
    margin-bottom: 10px;
}

.section li:last-child {
    margin-bottom: 0;
}

.section a,
.section span {
    display: inline-block;
    font-size: 16px;
    color: #333;
    text-decoration: none;
    line-height: 1.6;
    transition: color 0.2s ease;
}

.section a:hover {
    color: #00566A;
    text-decoration: underline;
}

.section span {
    color: #666;
}

/* Mobile */
@media (max-width: 768px) {
    .sitemap-page {
        padding: 24px 16px;
    }

    .sitemap-page h1 {
        font-size: 30px;
        margin-bottom: 24px;
    }

    .sitemap-grid {
        gap: 24px;
    }

    .section {
        padding-bottom: 20px;
    }

    .section h2 {
        font-size: 20px;
        margin-bottom: 12px;
    }

    .section a,
    .section span {
        display: block;
        padding: 6px 0;
        font-size: 15px;
    }
}
</style>
<div class="dtfaboutus">
     <!--Announcement Banner Code-->
     <div class="dtf-alertpage"></div>


     <div class="sitemap-page">
          
          <h1>Sitemap</h1>
          <div class="card">
          <div class="sitemap-grid">
               <div class="section" *ngFor="let section of sitemapSections">
                    <h2>{{ section.title }}</h2>

                    <ul>
                         <li *ngFor="let link of section.links">

                              <!-- Action links -->
                              <a *ngIf="link.action" href="javascript:void(0)" (click)="handleAction(link.action)">
                                   {{ link.label }}
                              </a>

                              <!-- External links -->
                              <a *ngIf="!link.action && link.external" [href]="link.url" target="_blank"
                                   rel="noopener noreferrer">
                                   {{ link.label }}
                              </a>

                              <!-- Internal links -->
                              <a *ngIf="!link.action && !link.external && link.url" [href]="link.url">
                                   {{ link.label }}
                              </a>

                              <span *ngIf="!link.action && !link.url">
                                   {{ link.label }}
                              </span>

                         </li>
                    </ul>
               </div>
          </div>
          </div>
     </div>
</div>
</div>